import { RefreshIcon, BriefcaseIcon, LibraryIcon, CurrencyRupeeIcon, UserGroupIcon, EmojiHappyIcon } from "./icons";

export const menuOptions = [{ id: "#home", text: "Home" }, { id: "#features", text: "Features" }, { id: "#aboutus", text: "About Us" }, { id: "#testimonials", text: "Testimonials" }, { id: "#blogs", text: "Blogs" }, { id: "#contact", text: "Contact" }];

export const features = [
  {
    id: 'Marketing-Consulting',
    icon: <RefreshIcon />,
    title: 'Marketing Consulting',
    subTitle: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Perferendis quis molestiae vitae eligendi at.'
  },
  {
    id: 'Market-Analysis',
    icon: <LibraryIcon />,
    title: 'Market Analysis',
    subTitle: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Perferendis quis molestiae vitae eligendi at.'
  },
  {
    id: 'Easy-Purchase',
    icon: <CurrencyRupeeIcon />,
    title: 'Easy Purchase',
    subTitle: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Perferendis quis molestiae vitae eligendi at.'
  },
  {
    id: 'Free-Updates',
    icon: <UserGroupIcon />,
    title: 'Free Updates',
    subTitle: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Perferendis quis molestiae vitae eligendi at.'
  },
  {
    id: '100%-Satistified',
    icon: <EmojiHappyIcon />,
    title: '100% Satistified',
    subTitle: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Perferendis quis molestiae vitae eligendi at.'
  },
  {
    id: 'Easy-Plugin',
    icon: <BriefcaseIcon />,
    title: 'Easy Plugin',
    subTitle: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Perferendis quis molestiae vitae eligendi at.'
  },
]

export const featureTwoColumnSectionContent = [{
  id: 'section-1',
  mainUrl: 'https://gist.githubusercontent.com/Akashnb/47ca4c5e0085a7321a47810ae26c0ca0/raw/21e01b8e24c2c54c77010f5c9865a11eb1f59536/image-three.svg',
  title: 'Communicate and gather feedback',
  subTitle: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem neque nisi architecto autem molestias corrupti officia veniam.',
  authorCardContent: {
    authorImgUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    authorName: 'Grey Simpson',
    authorDesignation: 'Co-Founder, XYZ Inc.',
    quote: '“Lorem iblockquotesum dolor sit amet, consectetur adipisicing elit. Ducimus vitae ipsa asperiores inventore aperiam iure?”'
  }
},
{
  id: 'section-2',
  mainUrl: 'https://gist.githubusercontent.com/Akashnb/1152b49cbe072201e8054e3ac368979a/raw/a4ec5882a84686f5c726ab341a0af6d9f12e84da/image-two.svg',
  title: 'Communicate and gather feedback',
  subTitle: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem neque nisi architecto autem molestias corrupti officia veniam.',
  authorCardContent: {
    authorImgUrl: 'https://preview.colorlib.com/theme/imagine/images/xperson_1.jpg.pagespeed.ic.7rsO3E8HOL.webp',
    authorName: 'Kimberly Gush',
    authorDesignation: 'Co-Founder, XYZ Inc.',
    quote: '“Lorem iblockquotesum dolor sit amet, consectetur adipisicing elit. Ducimus vitae ipsa asperiores inventore aperiam iure?”'
  }
},
{
  id: 'section-3',
  mainUrl: 'https://gist.githubusercontent.com/Akashnb/47ca4c5e0085a7321a47810ae26c0ca0/raw/21e01b8e24c2c54c77010f5c9865a11eb1f59536/image-three.svg',
  title: 'Communicate and gather feedback',
  subTitle: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem neque nisi architecto autem molestias corrupti officia veniam.',
  authorCardContent: {
    authorImgUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    authorName: 'Grey Simpson',
    authorDesignation: 'Co-Founder, XYZ Inc.',
    quote: '“Lorem iblockquotesum dolor sit amet, consectetur adipisicing elit. Ducimus vitae ipsa asperiores inventore aperiam iure?”'
  }
},
{
  id: 'section-4',
  mainUrl: 'https://gist.githubusercontent.com/Akashnb/1152b49cbe072201e8054e3ac368979a/raw/a4ec5882a84686f5c726ab341a0af6d9f12e84da/image-two.svg',
  title: 'Communicate and gather feedback',
  subTitle: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem neque nisi architecto autem molestias corrupti officia veniam.',
  authorCardContent: {
    authorImgUrl: 'https://preview.colorlib.com/theme/imagine/images/xperson_1.jpg.pagespeed.ic.7rsO3E8HOL.webp',
    authorName: 'Kimberly Gush',
    authorDesignation: 'Co-Founder, XYZ Inc.',
    quote: '“Lorem iblockquotesum dolor sit amet, consectetur adipisicing elit. Ducimus vitae ipsa asperiores inventore aperiam iure?”'
  },
}]

export const TeamMembers = [{
  profileUrl: 'https://preview.colorlib.com/theme/imagine/images/xperson_1.jpg.pagespeed.ic.7rsO3E8HOL.webp',
  title: 'Cloe Marena',
  designation: 'PRESIDENT',
  description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatum excepturi corporis qui doloribus perspiciatis ipsa modi accusantium repellat.',
},
{
  profileUrl: 'https://preview.colorlib.com/theme/imagine/images/xperson_2.jpg.pagespeed.ic.tEQmGoVJYm.webp',
  title: 'John Rooster',
  designation: 'MARKETING',
  description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatum excepturi corporis qui doloribus perspiciatis ipsa modi accusantium repellat.',
},
{
  profileUrl: 'https://preview.colorlib.com/theme/imagine/images/xperson_3.jpg.pagespeed.ic.RShAAJX8ye.webp',
  title: 'Will Turner',
  designation: 'MARKETING',
  description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatum excepturi corporis qui doloribus perspiciatis ipsa modi accusantium repellat.',
}, {
  profileUrl: 'https://preview.colorlib.com/theme/imagine/images/xperson_4.jpg.pagespeed.ic.zElXCyQBvP.webp',
  title: 'Nicolas Stainer',
  designation: 'FINANCING',
  description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatum excepturi corporis qui doloribus perspiciatis ipsa modi accusantium repellat.',
},
{
  profileUrl: 'https://preview.colorlib.com/theme/imagine/images/xperson_5.jpg.pagespeed.ic.70eErTeu-L.webp',
  title: 'George Brook',
  designation: 'FOUNDER',
  description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatum excepturi corporis qui doloribus perspiciatis ipsa modi accusantium repellat.',
},
{
  profileUrl: 'https://preview.colorlib.com/theme/imagine/images/xperson_6.jpg.pagespeed.ic.sAuv9jH-0q.webp',
  title: 'Emely Hopson',
  designation: 'MARKETING',
  description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatum excepturi corporis qui doloribus perspiciatis ipsa modi accusantium repellat.',
}]

export const TestimonialContent = [{
  id: 'testimonial-1',
  profileUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  quote: '“Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur unde reprehenderit aperiam quaerat fugiat repudiandae explicabo animi minima fuga beatae illum eligendi incidunt consequatur. Amet dolores excepturi earum unde iusto.”',
  name: 'John Smith',
},
{
  id: 'testimonial-2',
  profileUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  quote: '“Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur unde reprehenderit aperiam quaerat fugiat repudiandae explicabo animi minima fuga beatae illum eligendi incidunt consequatur. Amet dolores excepturi earum unde iusto.”',
  name: 'Robert Aguilar',
},
{
  id: 'testimonial-3',
  profileUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  quote: '“Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur unde reprehenderit aperiam quaerat fugiat repudiandae explicabo animi minima fuga beatae illum eligendi incidunt consequatur. Amet dolores excepturi earum unde iusto.”',
  name: 'Roger Spears',
},
{
  id: 'testimonial-4',
  profileUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  quote: '“Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur unde reprehenderit aperiam quaerat fugiat repudiandae explicabo animi minima fuga beatae illum eligendi incidunt consequatur. Amet dolores excepturi earum unde iusto.”',
  name: 'Kyle McDonald',
}]

export const Blogs = [{
  id: 'blog-1',
  url: 'https://preview.colorlib.com/theme/imagine/images/ximg_2.jpg.pagespeed.ic.f8blglsL85.webp',
  name: 'Ham Brook',
  date: '1 1, 2022',
  title: 'Make Your Business More Profitable',
  content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Natus eligendinobis ea maiores sapiente veritatis reprehenderit suscipit quaerat rerumvoluptatibus a eius.',
  blogType: 'News',
},
{
  id: 'blog-2',
  url: 'https://preview.colorlib.com/theme/imagine/images/ximg_1.jpg.pagespeed.ic.CEoAKbN9Wd.webp',
  name: 'James Phelps',
  date: '5 1, 2022',
  title: 'Make Your Business More Profitable',
  content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Natus eligendinobis ea maiores sapiente veritatis reprehenderit suscipit quaerat rerumvoluptatibus a eius.',
  blogType: 'News',
},
{
  id: 'blog-3',
  url: 'https://preview.colorlib.com/theme/imagine/images/ximg_3.jpg.pagespeed.ic.PYTtDsT5yr.webp',
  name: 'Tonny robbins',
  date: '15 1, 2022',
  title: 'Make Your Business More Profitable',
  content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Natus eligendinobis ea maiores sapiente veritatis reprehenderit suscipit quaerat rerumvoluptatibus a eius.',
  blogType: 'News',
}]